import { IJrwaClassification } from "api/jrwaService";

// Drzewo JRWA z listy płaskiej (BE zwraca pozycje z ParentId) + kategorie archiwalne.

/** Kategorie archiwalne (Kwantum.Enums.ArchiveType z EPM). */
export const ARCHIVE_TYPES: { value: number; label: string }[] = [
  { value: 0, label: "Nie wybrano" },
  { value: 1, label: "A" },
  { value: 2, label: "B" },
  { value: 3, label: "B3" },
  { value: 4, label: "B5" },
  { value: 5, label: "B6" },
  { value: 6, label: "B10" },
  { value: 7, label: "B40" },
  { value: 8, label: "B50" },
  { value: 9, label: "BE5" },
  { value: 10, label: "BE10" },
  { value: 11, label: "BE50" },
];

export const archiveTypeLabel = (v?: number | null) =>
  ARCHIVE_TYPES.find((a) => a.value === v)?.label ?? "";

// ── Drzewo z listy płaskiej ───────────────────────────────────────────────────

export interface IJrwaNode {
  id: string;
  code: string;
  label: string;
  children: IJrwaNode[];
  custom: boolean;
  isArchived: boolean;
  archiveType?: number | null;
  casesCount: number;
  parentId?: string | null;
  /** „Pracownicy prowadzą teczki wspólnie" — prowadzący widzą teczki pod kodem. */
  isShared: boolean;
  /** Prowadzący kod (UserId członków firmy). */
  userIds: string[];
}

export const buildJrwaTree = (items: IJrwaClassification[]): IJrwaNode[] => {
  const map = new Map<string, IJrwaNode>();
  for (const c of items) {
    map.set(c.Id, {
      id: c.Id,
      code: c.Code,
      label: c.Description,
      children: [],
      custom: !c.IsReadOnly,
      isArchived: c.IsArchived,
      archiveType: c.ArchiveType,
      casesCount: c.CasesCount,
      parentId: c.ParentId,
      isShared: !!c.IsShared,
      userIds: c.UserIds ?? [],
    });
  }
  const roots: IJrwaNode[] = [];
  const collator = new Intl.Collator("pl", { numeric: true });
  for (const n of map.values()) {
    const parent = n.parentId ? map.get(n.parentId) : undefined;
    if (parent) parent.children.push(n);
    else roots.push(n);
  }
  const sortRec = (nodes: IJrwaNode[]) => {
    nodes.sort((a, b) => collator.compare(a.code, b.code));
    nodes.forEach((n) => sortRec(n.children));
  };
  sortRec(roots);
  return roots;
};

